var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2335 0.666626H4.76649C2.13823 0.666626 0 2.80486 0 5.43311V11.9001C0 14.5284 2.13823 16.6666 4.76649 16.6666H11.2335C13.8618 16.6666 16 14.5284 16 11.9001V5.43311C16 2.80486 13.8617 0.666626 11.2335 0.666626ZM14.3904 11.9001C14.3904 13.6436 12.977 15.057 11.2335 15.057H4.76649C3.023 15.057 1.6096 13.6436 1.6096 11.9001V5.43311C1.6096 3.6896 3.023 2.27623 4.76649 2.27623H11.2335C12.977 2.27623 14.3904 3.6896 14.3904 5.43311V11.9001Z",
    fill: "url(#paint0_linear_829_80)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 4.52844C5.7182 4.52844 3.86182 6.38482 3.86182 8.66658C3.86182 10.9483 5.7182 12.8048 7.99999 12.8048C10.2818 12.8048 12.1382 10.9484 12.1382 8.66658C12.1382 6.38479 10.2818 4.52844 7.99999 4.52844ZM7.99999 11.1952C6.60348 11.1952 5.47142 10.0631 5.47142 8.66661C5.47142 7.27011 6.60351 6.13804 7.99999 6.13804C9.39649 6.13804 10.5286 7.27011 10.5286 8.66661C10.5286 10.0631 9.39646 11.1952 7.99999 11.1952Z",
    fill: "url(#paint1_linear_829_80)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.146 5.55112C12.6936 5.55112 13.1375 5.10718 13.1375 4.55955C13.1375 4.01193 12.6936 3.56799 12.146 3.56799C11.5984 3.56799 11.1544 4.01193 11.1544 4.55955C11.1544 5.10718 11.5984 5.55112 12.146 5.55112Z",
    fill: "url(#paint2_linear_829_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_829_80",
    x1: 8,
    y1: 16.62,
    x2: 8,
    y2: 0.790895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_80",
    x1: 7.99999,
    y1: 16.62,
    x2: 7.99999,
    y2: 0.790881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_829_80",
    x1: 12.146,
    y1: 16.62,
    x2: 12.146,
    y2: 0.790867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.9969aa7a8753c226e5be11fdb16b610b.svg";
export { ForwardRef as ReactComponent };